import { render, staticRenderFns } from "./KirchenVostand.vue?vue&type=template&id=7ad88528&scoped=true&"
import script from "./KirchenVostand.vue?vue&type=script&lang=js&"
export * from "./KirchenVostand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad88528",
  null
  
)

export default component.exports